import { render, staticRenderFns } from "./AppBanner.global.vue?vue&type=template&id=2f453290&lang=pug&"
import script from "./AppBanner.global.vue?vue&type=script&lang=ts&"
export * from "./AppBanner.global.vue?vue&type=script&lang=ts&"
import style0 from "./AppBanner.global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports